export default ["en", "ua"];
